import authInterceptor from "../AuthInterceptor";

export const PlaygroundAPI = {
    runSimulation: (bodyData, config = {}) =>
        authInterceptor.post(`ranking-api/playground/simulate/`, bodyData, {
            ...config,
            params: {
                page: bodyData?.page || 1,
                page_size: bodyData?.page_size || 5,
                ...(bodyData?.search ? { search: bodyData.search } : {}),
                ...(config?.params || {}),
            },
        })
            .then((response) => response.data)
            .catch((error) => error.response),
    applyChanges: (bodyData, config = {}) =>
        authInterceptor.post(`ranking-api/playground/apply/`, bodyData, config)
            .then((response) => response.data)
            .catch((error) => error.response),
}
